import { useCallback, useEffect, useMemo, useState } from 'react';

import { RadioOptionsWithConfirm } from 'shared-components';
import { VisaStatus } from 'types';

import { IQuestion, IVisaStatus } from '../../../../../../../../../types';

interface IProps {
  setComplete: (status: boolean) => void;
  additionalAnswers: {
    setStatus: (status: IVisaStatus) => void;
  };
}
export const VisaApplied = (props: IProps) => {
  const {
    setComplete,
    additionalAnswers: { setStatus }
  } = props;

  const [selection, setSelection] = useState('');

  useEffect(() => {
    if (Object.values(VisaStatus).includes(selection as VisaStatus)) {
      setStatus(selection as VisaStatus);

      setComplete(true);
    } else {
      setComplete(false);
    }
  }, [selection, setStatus, setComplete]);

  const questions = useMemo(
    () => [
      {
        char: '1',
        label: 'I have received my visa',
        selected: selection === VisaStatus.VISA_RECEIVED,
        status: VisaStatus.VISA_RECEIVED // not returned on onClick
      },
      {
        char: '2',
        label: `I am still waiting to hear back from UKVI`,
        selected: selection === VisaStatus.AWAITING_VISA_RESPONSE,
        status: VisaStatus.AWAITING_VISA_RESPONSE // not returned on onCl
      },
      {
        char: '3',
        label: 'UKVI has requested more information',
        selected: selection === VisaStatus.UKVI_REQUEST_MORE_INFO,
        status: VisaStatus.UKVI_REQUEST_MORE_INFO // not returned on onCl
      },
      {
        char: '4',
        label: 'I received a visa refusal',
        selected: selection === VisaStatus.VISA_REFUSAL,
        status: VisaStatus.VISA_REFUSAL // not returned on onCl
      }
    ],
    [selection]
  );

  const getVisaStatusFromLabel = useCallback(
    (label: string) => {
      return questions.find(question => question.label === label)!.status;
    },
    [questions]
  );

  return (
    <div data-selector="enrolment-section-visa-status-response">
      <RadioOptionsWithConfirm
        label={`Have you received a response?`}
        questions={questions}
        onClick={(question: IQuestion) => {
          setSelection(getVisaStatusFromLabel(question.label));
          return true;
        }}
      />
    </div>
  );
};
